import React, { Suspense } from "react"
import BlurBackground, {
  BlurBackgroundProps,
} from "./BlurBackground/BlurBackground"
import elementSplitter from "./utils/elementSplitter"
import Content from "./Content/Content"

const Section = React.lazy(() => import("./Section/Section"))

type WidgetCenterPictureProps = {
  children: React.ReactElement
  topSpace?: number | string
  gap?: number
  backgroundType?: BlurBackgroundProps["type"]
  autoSize?: boolean
}

const WidgetCenterPicture = ({
  children,
  topSpace = 100,
  gap = 70,
  backgroundType,
  autoSize,
}: WidgetCenterPictureProps) => {
  //
  const { headers, paragraphs, images, components, svgs } =
    elementSplitter(children)

  // Main Image
  const mainImage =
    images[0] &&
    React.cloneElement(images[0] as React.ReactElement, {
      style: {
        ...images[0].props.style,
        width: "600px",
        borderRadius: "8px",
        margin: 0,
      },
    })

  // Decorative SVG
  const decorativeSVG =
    svgs[0] &&
    (svgs[1] ? (
      <>
        {React.cloneElement(svgs[0] as React.ReactElement, {
          style: { ...svgs[0].props.style, width: "50px", marginTop: "30px" },
        })}
        {React.cloneElement(svgs[1] as React.ReactElement, {
          style: { ...svgs[1].props.style, width: "16px" },
        })}
      </>
    ) : (
      React.cloneElement(svgs[0] as React.ReactElement, {
        style: { ...svgs[0].props.style, width: "50px", marginTop: "30px" },
      })
    ))

  return (
    <Content rows={2} gap={gap} topSpace={topSpace} autoSize={autoSize}>
      <Section>{headers}</Section>

      <Suspense fallback={<h4>Loading...</h4>}>
        <Section>{mainImage}</Section>
      </Suspense>

      <Section y="top" x="left">
        {paragraphs}
        {components}
      </Section>
      <Section>{decorativeSVG}</Section>

      {backgroundType && (
        <BlurBackground direction="center" type={backgroundType} />
      )}
    </Content>
  )
}

export default WidgetCenterPicture
